import type { RouteMatch } from '@confluence/route/entry-points/Route.ts';
import { fg } from '@confluence/feature-gating';
import { isEmbeddedWhiteboardMode } from '@confluence/whiteboard-common/entry-points/isEmbeddedWhiteboardMode.ts';

const getSingle = (value: string | string[] | null | undefined): string | undefined =>
	Array.isArray(value) ? value[0] : (value ?? undefined);

export type EmbeddedWhiteboardContext = {
	isEmbeddedWhiteboardMode: boolean;
	bypassesMainLayout: boolean;
	parentProduct?: string;
	isSmartLinkEmbed: boolean;
	isRovoEmbed: boolean;
};

export const getEmbeddedWhiteboardContext = (match: RouteMatch): EmbeddedWhiteboardContext => {
	const isEmbedded = isEmbeddedWhiteboardMode({
		parentProduct: match.query?.parentProduct,
		presentationMode: match.query?.presentationMode,
	});

	const parentProduct = getSingle(match.query?.parentProduct);
	return {
		isEmbeddedWhiteboardMode: isEmbedded,
		// oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
		bypassesMainLayout: isEmbedded && fg('confluence_ssr_embedded_whiteboard_preload_cache'),
		parentProduct,
		isSmartLinkEmbed: parentProduct === 'smartLink',
		isRovoEmbed: parentProduct === 'rovo',
	};
};
